<template>
  <component :is="readOnly ? 'pre' : 'b-form-textarea'"
             :class="{'bg-gray-150 mb-0':readOnly}" :style="style"
             type="text" class="form-control form-control-sm" v-model="valueFromProp">{{ valueFromProp }}</component>
</template>

<script>
  export default {
    name: 'gtc-textarea',
    props: {
      readOnly: {
        type: Boolean,
        default: false
      },
      value: {
        default: null
      }
    },
    computed: {
      style() {
        if (this.readOnly) {
          return {
            'height': 'auto',
            'white-space': 'pre-line'
          };
        }
        else
          return null;
      }
    },
    data: function () {
      return {
        valueFromProp: null
      }
    },
    created() {
      this.valueFromProp = this.value;
    },
    watch: {
      valueFromProp(newVal, oldVal) {
        let self = this;
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal))
          self.$emit('input', newVal);
      },
      value(newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal))
          this.valueFromProp = newVal;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/framework/GtcTextarea.vue